import React from 'react';
import { ClipLoader } from 'react-spinners';
import styled from 'styled-components';
import { colors } from 'styleguide/colors';
import { P2 } from 'styleguide/Texts';
import { t } from 'translations/t';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

export const LoadingSpinner = ({ backgroundColor }: { backgroundColor?: string }) => (
  <Container style={backgroundColor ? { backgroundColor } : {}}>
    <P2 style={{ marginBottom: 20 }}>{t('global.loading.ellipsis')}</P2>
    <ClipLoader size={30} color={colors.primary} loading={true} />
  </Container>
);
